import { useAppState } from "./appStateContext"
import useCountdown from "./useCountdown"

const usePromoCountdown = () => {
  const productData = useAppState().state.productData
  const promoEndDate = productData?.promoEndDate
  const promoRemaining = productData?.promoRemainingSeconds

  return useCountdown({
    endDateSeconds: promoEndDate,
    maxSeconds: promoRemaining,
  })
}

export default usePromoCountdown
